import React from 'react';
import chevronRight from '../../styles/img/arrow/vector.svg';
import { useSelector } from 'react-redux';
import { STORE_LIST } from '../../constants/routes';
import { useNavigate } from 'react-router';
import { isAllowToChangeStore } from '../../utils/Validator';
import { isAppPWA } from '../../utils/helper-functions';
import { useTheme } from 'styled-components';
import { IoChevronDown, IoLocationSharp } from 'react-icons/io5';

const StoreSelectionButton = ({ originPath, titleIsVisible,user = false }) => {
  const navigate = useNavigate();
  const { store } = useSelector((state) => state.store);
  const theme = useTheme();

  const onClick = () => {
    const encodedStoreName = encodeURIComponent(
      store?.name?.split(' ')[0].toLowerCase() || '',
    );
    navigate(`${STORE_LIST}?view=stores&company=${encodedStoreName}`, {
      state: { prevPage: originPath },
    });
  };

  const storeName = store?.name?.split(' ')[0] ?? 'Ton magasin favori';

  const getStoreCityFontSize = (cityName) => {
    const length = cityName?.length ?? 0;
    if (length > 15) return '14px';
    if (length > 10) return '16px';
    return '16px';
  };

  if (!store) return null;

  return (
    <div
      className="store-selection-button relative"
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label={`Sélectionner le magasin ${storeName}`}
      onKeyPress={(e) => e.key === 'Enter' && onClick()}
    >
      {theme?.buttonDecorations?.changeStoreButtonDecoration && (
        <img
          src={theme.buttonDecorations.changeStoreButtonDecoration?.image}
          alt="halloweee_tree"
          className="halloweee-tree"
        />
      )}
      {isAllowToChangeStore(store?.name) && titleIsVisible && (
        <div className="store-action">
          <div>Ton magasin</div>
        </div>
      )}
      <div className="store-detail">
        <div className="store-name-content">
          <img src={store.logo} alt="logo" className="store-img" />
        </div>
        <div className="container-city-chevron">
          <div
            className="store-city"
            style={{ fontSize: getStoreCityFontSize(store.city) }}
          >
            {store.city}
            <IoChevronDown size={14} color="#596802" />
          </div>
        </div>
      </div>
      <div className="store-address ml-2">
        <div className="bg-indigo-100 rounded-full p-1 flex items-center justify-center">
          <IoLocationSharp size={10} color="#596802" />
        </div>
        {store.address}, {store.postalCode} {store.city}
      </div>
    </div>
  );
};

export default StoreSelectionButton;
